import React, {useEffect} from "react";
import {Helmet} from "react-helmet";
import "./kamolac.css";
import KamoHeader from "./KamoHeader";
import Footer from "../../layout/Footer";
import KamolacFooter from "./KamolacFooter";


export default function HDXMasterclass() {
  
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
     
  return (

    <>
    <Helmet>
      <title>HD-X Masterclass Wood Finishes - Kamolac by Kamdhenu Paints</title>
      <meta name="description" content="HD-X Wood Finishes by Kamolac offer unparalleled clarity and non-yellowing properties, ideal for light-colored wood surfaces." />
      <link rel="canonical" href="https://www.kamdhenupaints.com/hdx-masterclass" />
    </Helmet>
    <KamoHeader />
         <div className="hdx">

      {/* HERO */}
      <section className="hero-modern">
        <img src={process.env.PUBLIC_URL + '/images/products/new/2-banners.png'} alt="" />
        <div className="hero-content">
          <h1>HD-X Wood Finishes – The Perfectionists</h1>
          <p>
            If PU finishes are the "workhorse" of the industry, HD-X Wood Finishes are the "perfectionists." HD-X coatings are prized for their unparalleled clarity and non-yellowing properties, making them the premier choice for light-colored woods like Ash, Maple, or Birch.
          </p>
        </div>
      </section>

      {/* WHY SECTION (Split Layout) */}
      <section className="split">
        <div className="split-text">
          <h2>Why Choose HD-X Wood Finishes?</h2>
          <p>
            HD-X resins are naturally transparent and UV-stable. Unlike traditional finishes that may amber or "warm up" over time, HD-X stays water-white, ensuring the wood’s natural color remains exactly as the day it was coated.
          </p>
        </div>
        <div className="split-img">
          <img src={process.env.PUBLIC_URL + '/images/products/new/6.png'} alt="" />
        </div>
      </section>

      {/* IMAGE GRID (Luxury Feel) */}
      <section className="image-grid">
        <img src={process.env.PUBLIC_URL + '/images/products/new/1.png'} alt="" />
        <img src={process.env.PUBLIC_URL + '/images/products/new/3.png'} alt="" />
        <img src={process.env.PUBLIC_URL + '/images/products/new/4.jpeg'} alt="" />
      </section>

      {/* SHEEN CARDS */}
      <section className="container">
        <h2>Our HD-X Sheen Range</h2>
        <p>
          Available in three distinct levels of reflection to suit your architectural style:
        </p>

        <div className="cards modern scmodern" >
          <div className="card glass">
            {/* <img src={process.env.PUBLIC_URL + '/images/products/new/4.jpeg'} alt="" /> */}
            <div className="card-content">
              <h4>HD-X Matt: The "Invisible" Shield</h4>
              <p>Designed for those who want the wood to look completely untreated while having full professional protection.
</p>
              <p><strong>Appearance:</strong> A flat, sophisticated finish with 5–10% sheen.</p>
              <p><strong>Best For:</strong> Modern "Raw Wood" aesthetics and rustic furniture.</p>
              <p><strong>Key Benefit:</strong> Exceptional at resisting fingerprints and diffusing harsh overhead lighting.</p>
            </div>
          </div>

          <div className="card glass">
            {/* <img src={process.env.PUBLIC_URL + '/images/products/new/4.jpeg'} alt="" /> */}
            <div className="card-content">
              <h4>HD-X Semi-Gloss: The Silky Satin</h4>
              <p>A versatile, soft-focus finish that brings a subtle "inner glow" to the wood grain.
</p>
              <p><strong>Appearance:</strong> A smooth, velvety luster with 35–50% sheen.</p>
              <p><strong>Best For:</strong> Premium cabinetry, wall paneling, and designer wardrobes.</p>
              <p><strong>Key Benefit:</strong> Striking the perfect balance between ease of cleaning and aesthetic depth.</p>
            </div>
          </div>

          <div className="card glass">
            {/* <img src={process.env.PUBLIC_URL + '/images/products/new/4.jpeg'} alt="" /> */}
            <div className="card-content">
              <h4>HD-X High Gloss: The Liquid Glass</h4>
              <p>The pinnacle of clarity. Because the resin is so clear, the gloss level feels deeper and more "3D" than other finishes.
</p>
              <p><strong>Appearance:</strong> High-reflectivity "wet look" with 90%+ sheen.</p>
              <p><strong>Best For:</strong> Luxury accent pieces, high-end retail fixtures, and polished tabletops.</p>
              <p><strong>Key Benefit:</strong> Incredible depth of field that makes the wood grain "pop" with high-definition detail.</p>
            </div>
          </div>
        </div>
      </section>

      {/* PERFORMANCE (Overlay Section) */}
      <section className="overlay-section">
        <img src={process.env.PUBLIC_URL + '/images/products/new/3-banner.png'} alt="" />
        <div className="overlay-box">
          <h2>Performance Highlights</h2>
          <ul>
            <li><strong>Non-Yellowing:</strong> Guaranteed to stay crystal clear, even when exposed to sunlight near windows.</li>
            <li><strong>Fast Drying:</strong> Significantly faster curing times than PU, allowing for quicker project completion.</li>
            <li><strong>Hardness & Scratch Resistance:</strong> Formulated to withstand the rigors of high-end residential and commercial use.</li>
            <li><strong>Environmental Friendliness:</strong> Low VOC options are available, making it a "greener" choice for indoor air quality.</li>
          </ul>
        </div>
      </section>

      {/* TABLE */}
      <section className="container">
        <h2>PU vs. HD-X: Which one do you need?</h2>

        <div className="table-modern">
          <table>
            <thead>
              <tr>
                <th>Feature</th>
                <th>PU (Polyurethane)</th>
                <th>HD-X</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Color Clarity</td>
                <td>May yellow slightly over years</td>
                <td>Stays Water-White</td>
              </tr>
              <tr>
                <td>Toughness</td>
                <td>High (Great for floors)</td>
                <td>Moderate-High (Great for furniture)</td>
              </tr>
              <tr>
                <td>Drying Time</td>
                <td>Slower</td>
                <td>Much Faster</td>
              </tr>
              <tr>
                <td>Best Application</td>
                <td>Darker woods / Heavy-duty</td>
                <td>Light woods / High-end design</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

    </div>
<KamolacFooter />
    </>
  );
}

/* CSS FILE: hdx.css */
